import { Image, ImageProps } from '@chakra-ui/react'
import svg from 'assets/artwork/man-chair.svg'
import { forwardRef } from 'react'

export const ManChair = forwardRef<HTMLImageElement, ImageProps>((props, ref) => {
    return <Image {...props} src={svg} alt="a person in a chair" ref={ref} />
})
